<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('question.addNewCatalog') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div class="form-group row">
        <div class="col-md-12">
          <label>
            {{ $t('question.catalogNameKh') }}
          </label>
          <input
            type="text"
            class="form-control"
            v-model="model.question_catalog_name_kh"
            :placeholder="$t('question.catalogNameKh')"
            ref="question_catalog_name_kh"
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label class="required">
            {{ $t('question.catalogNameEn') }}
          </label>
          <input
            type="text"
            class="form-control"
            v-model="model.question_catalog_name_en"
            :placeholder="$t('question.catalogNameEn')"
            :class="{ 'is-invalid': errors.has('question_catalog_name_en') }"
            ref="question_catalog_name_en"
          />
          <div
            class="invalid-feedback"
            v-if="errors.has('question_catalog_name_en')"
          >
            {{ errors.first('question_catalog_name_en') }}
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label>
            {{ $t('question.description') }}
          </label>
          <textarea
            class="form-control"
            v-model="model.description"
            :placeholder="$t('question.description')"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click="$emit('close')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button :waiting="saving" color="primary" @click.prevent="save">{{
            $t('save')
          }}</ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>
<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'addCatalog',
  data() {
    return {
      saving: false,
      errors: new Errors(),
      model: {
        question_catalog_name_kh: '',
        question_catalog_name_en: '',
        description: ''
      }
    }
  },
  mounted() {
    this.$refs.question_catalog_name_kh.focus()
  },
  methods: {
    save() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('eschool/eExam/catalog/store', { ...this.model })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.$refs.question_catalog_name_en.focus()
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
